export enum GraphQLPageStatus {
	CURRENT = 'CURRENT',
	DRAFT = 'DRAFT',
}

export const PAGE_TREE_STATUSES: GraphQLPageStatus[] = [
	GraphQLPageStatus.CURRENT,
	GraphQLPageStatus.DRAFT,
];
